import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// ─────────────────────────────────────────────────────────────────────────────
// AuthCallback.js
// Route: /auth/callback
// The backend redirects here after Google OAuth with #token=xxx&role=xxx
// We read the fragment, store the token, and redirect to the dashboard.
// Using a URL fragment (#) instead of query (?token=) is intentional —
// fragments are never sent to servers so the token stays client-side only.
// ─────────────────────────────────────────────────────────────────────────────
export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    // Parse fragment: #token=xxx&role=user
    const hash = window.location.hash.slice(1); // remove leading #
    const params = new URLSearchParams(hash);
    const token = params.get('token');
    const role  = params.get('role');

    if (!token) {
      // Check for error in query string (e.g. ?error=google_denied)
      const qp = new URLSearchParams(window.location.search);
      const err = qp.get('error') || 'unknown_error';
      setError(`Google sign-in failed: ${err.replace(/_/g,' ')}. Redirecting…`);
      setTimeout(() => navigate('/login?error=' + err), 2500);
      return;
    }

    // Store JWT exactly like normal login
    localStorage.setItem('token', token);

    // Redirect: admins → /admin, everyone else → /profile
    const dest = ['admin','superadmin'].includes(role) ? '/admin' : '/profile';
    navigate(dest, { replace: true });
  }, []); // eslint-disable-line

  return (
    <div style={{
      minHeight:'100vh', display:'flex', flexDirection:'column',
      alignItems:'center', justifyContent:'center',
      background:'linear-gradient(145deg,#06112b,#112359)',
      fontFamily:'DM Sans,sans-serif', gap:14, color:'#e2e8f0',
    }}>
      {error ? (
        <>
          <div style={{fontSize:40}}>❌</div>
          <div style={{fontSize:14,color:'#f87171',maxWidth:300,textAlign:'center'}}>{error}</div>
        </>
      ) : (
        <>
          <div style={{
            width:36, height:36,
            border:'3px solid rgba(28,115,186,0.2)', borderTopColor:'#1c73ba',
            borderRadius:'50%', animation:'spin 0.75s linear infinite',
          }}/>
          <div style={{fontSize:14,color:'#64748b'}}>Signing you in with Google…</div>
          <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        </>
      )}
    </div>
  );
}